import {Component, EventEmitter, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {KENDO_DROPDOWNS} from '@progress/kendo-angular-dropdowns';
import {TranslocoModule} from '@jsverse/transloco';
import {FiltreAccueilPeriode} from '../../FiltreAccueilPeriode';

//Composant de sélection du filtre temporel du dashboard
@Component (
{
	selector: 'val-dashboard-filtre-temporel',
	imports:
	[
		FormsModule,
		KENDO_DROPDOWNS,
		TranslocoModule
	],
	templateUrl: './dashboard-filtre-temporel.component.html',
	styleUrl: './dashboard-filtre-temporel.component.scss'
})
export class DashboardFiltreTemporelComponent
{
	//Création
	constructor ()
	{
		this.periodeSelectionnee = FiltreAccueilPeriode.TrenteJours;
		this.filtreChange        = new EventEmitter<FiltreAccueilPeriode> ();
		this.optionsPeriode      =
		[
			FiltreAccueilPeriode.SeptJours,
			FiltreAccueilPeriode.TrenteJours,
			FiltreAccueilPeriode.TroisMois,
			FiltreAccueilPeriode.DouzeJours
		];
	}

	//Liste des options de période disponibles
	public readonly optionsPeriode: FiltreAccueilPeriode[];

	//Période actuellement sélectionnée
	public periodeSelectionnee: FiltreAccueilPeriode;

	//Événement émis lors du changement de période
	@Output ()
	public filtreChange: EventEmitter<FiltreAccueilPeriode>;

	//Traite le changement de période sélectionnée
	public OnPeriodeChange (periode: FiltreAccueilPeriode) : void
	{
		this.filtreChange.emit (periode);
	}
}
